export interface PageDetailsInterface {
    pageComponent:any
}
export const initPageDetails = {
    pageComponent:null
}

export const pageDetailsReducer = (state:PageDetailsInterface, action:any):PageDetailsInterface =>{
    return {...state, pageComponent:action.payload}
}